<app-connect-loader [loading]="loading">
  <app-bazenbanner></app-bazenbanner>
  <div class="contentbox">
    <app-controls-new [viewModel]="getControlsViewModel()"></app-controls-new>
    <app-schooldashboard-table></app-schooldashboard-table>
  </div>
</app-connect-loader>
